// import "bootstrap/dist/css/bootstrap.css";

import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from "pinia";
import { i18n, startLocale } from "./i18n";
const app = createApp(App);

// Pinia is used for shared storage 
app.use(createPinia());
app.use(i18n);
startLocale();
// Mounted into the container, NOT over <body>.
//
// Vue clears whatever it mounts into, so mounting to 'body' deleted every
// other child of it. That went unnoticed while index.html had nothing else in
// the body -- but a task page wraps the application in server-rendered HTML
// (masthead, heading, tutorial, questions, footer) which is the entire reason
// those pages can be indexed, and mounting to body wiped all of it the moment
// the bundle ran.
app.mount('#app');


// import "bootstrap/dist/js/bootstrap.js"
import "@/assets/styles/main.css";

import './assets/tailwind.css'